module.exports = __webpack_public_path__ + "static/media/left-arrow.36ecc5ef.svg";